<template>
    <div>
        <div class="main-button-bar">
            <el-button type="primary" size="small" @click="showAddDialog">新增账户</el-button>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 84"
            class="finance-account-table"
        >
            <el-table-column prop="number" label="账户" width="100"></el-table-column>
            <el-table-column prop="mail" label="邮箱地址" width="200"></el-table-column>
            <el-table-column prop="secret" label="秘钥" width="200"></el-table-column>
            <el-table-column prop="fromKey" label="关键字" width="200"></el-table-column>
            <el-table-column prop="frequency" label="同步周期（秒）" width="120"></el-table-column>
            <el-table-column prop="lastTime" label="最近同步时间" width="180">
                <template slot-scope="account">{{ $tools.timestampToTime(account.row.lastTime)}}</template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="account">
                    <el-tag type="success" v-if="account.row.status == 'Y'">可用</el-tag>
                    <el-tag type="danger" v-if="account.row.status == 'N'">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="account">
                    <el-button
                        v-if="account.row.status == 'Y'"
                        type="text"
                        size="small"
                        v-on:click="upstatus(account.row.id, 'N')"
                    >禁用</el-button>
                    <el-button
                        v-if="account.row.status == 'N' || !account.row.status"
                        type="text"
                        size="small"
                        v-on:click="upstatus(account.row.id, 'Y')"
                    >启用</el-button>
                    <el-button type="text" size="small" v-on:click="up(account.row.id)">修改</el-button>
                    <el-button
                        v-if="account.row.status == 'Y'"
                        type="text"
                        size="small"
                        v-on:click="dosync(account.row.id, 'N')"
                    >同步数据</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog
            :title="account && account.id ? '修改账户' : '新增账户'"
            :visible.sync="showDialog"
            width="500px"
            @closed="onclose"
        >
            <el-form ref="accountForm" :model="account" label-width="100px" :rules="rules">
                <el-form-item label="账户" prop="number">
                    <el-input v-model="account.number"></el-input>
                </el-form-item>

                <el-form-item label="邮箱地址" prop="mail">
                    <el-input v-model="account.mail"></el-input>
                </el-form-item>

                <el-form-item label="秘钥" prop="secret">
                    <el-input v-model="account.secret"></el-input>
                </el-form-item>

                <el-form-item label="关键字" prop="fromKey">
                    <el-input v-model="account.fromKey"></el-input>
                </el-form-item>

                <el-form-item label="同步周期（秒）" prop="frequency">
                    <el-input v-model="account.frequency"></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" class="op-button" @click="postAdd">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        return {
            showDialog: false,
            records: null,
            account: {},
            rules: {
                number: [
                    { required: true, message: "请输入名称", trigger: "blur" },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
                mail: [
                    { required: true, message: "请输入邮箱", trigger: "blur" },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
                secret: [
                    { required: true, message: "请输入私钥", trigger: "blur" },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
                fromKey: [
                    {
                        required: true,
                        message: "请输入关键字",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 128,
                        message: "长度在 2 到 128 个字符",
                        trigger: "blur",
                    },
                ],
                frequency: [
                    {
                        required: true,
                        message: "请输入关键字",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    methods: {
        showAddDialog() {
            this.shop = {};
            this.showDialog = true;
        },
        postAdd() {
            this.$refs["accountForm"].validate().then(this.doAdd);
        },
        doAdd() {
            let _this = this;

            _this.$http.post(
                ["finance/account/update", _this.account],
                [
                    function () {
                        _this.showDialog = false;
                        _this.shop = {};
                        _this.list();
                    },
                ],
                ".op-button"
            );
        },

        list() {
            let _this = this;

            _this.$http.post(
                ["finance/account/all"],
                [
                    function (data) {
                        _this.records = data;
                    },
                ],
                ".finance-account-tabnle"
            );
        },

        upstatus(id, status) {
            this.account.id = id;
            this.account.status = status;
            this.doAdd();
        },

        up(id) {
            let _this = this;

            _this.$http.post(
                ["finance/account/get", { id: id }],
                [
                    function (data) {
                        _this.account = data;
                        _this.showDialog = true;
                    },
                ],
                ".finance-account-tabnle"
            );
        },

        onclose() {
            this.$refs["accountForm"].resetFields();
        },

        dosync(id) {
            let _this = this;

            _this.$tConfirm.show("确认进行数据同步？", function () {
                _this.$http.post(
                    ["finance/account/trigger", { id: id }],
                    [
                        function (data) {
                            _this.list();
                        },
                    ],
                    ".finance-account-tabnle"
                );
            });
        },
    },
    mounted() {
        this.list();
    },
};
</script>

<style lang="scss">
</style>